export default [
    {
        path: 'relatorio-bpa-individualizado',
        component: () => import(
            /* webpackChunkName: 'bpa-relatorio-bpa-individualizado' */
            '@/views/bpa/relatorio-bpa-individualizado/Index'
        ),
        redirect: 'relatorio-bpa-individualizado/index',
        children: [
            {
                name: 'bpa-relatorio-bpa-individualizado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'bpa-relatorio-bpa-individualizado' */
                    '@/views/bpa/relatorio-bpa-individualizado/List.vue'
                ),
            },
        ],
    },
]